/** @format */

import { isA23 } from "../Stats";
import styles from "../Stats.module.css";

export default function PerformanceGrid({ title, items }) {
  if (!items || items.length === 0) return null;
  const parentContainerClass = isA23
    ? styles.statsPerformance
    : styles.statsAddaPerformance;
  const childContainerClass = isA23 ? styles.statCard : "flex flex-col";
  return (
    <div className="mt-[24px]">
      <div className="text-base font-medium mb-3">{title}</div>
      <div className={parentContainerClass}>
        {items.map(({ label, value, valueClass }) => {
          const valueClasses = `value text-[14px] font-bold ${valueClass}`;
          return (
            <div key={label} className={childContainerClass}>
              <div className={valueClasses}>{value}</div>
              <div className="label text-xs text-secondary">{label}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
